import React, {Component, useDebugValue, useSyncExternalStore} from 'react';
import { useState } from "react";
import { FaEdit } from "react-icons/fa";
import { Button, Alert, Modal, Col, FormControl } from 'react-bootstrap';
import CompetenciaDataService from './services/competencia.service.js';
import OrganigramaDataService from './services/organigrama.service.js';
import { Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Controller, useForm } from "react-hook-form";
import {dtForInputDate} from './AuxiliaryFunctions.js'

function AsignarOrganigrama(props) { 

  const { control, handleSubmit, formState: { errors },} = useForm({
    defaultValues: {
      /*
      primernombre: props.edituser.primernombre,      
      segundonombre: props.edituser.segundonombre,
      primerapellido: props.edituser.primerapellido,
      segundoapellido: props.edituser.segundoapellido,
      fechadenacimiento: dtForInputDate(props.edituser.fechadenacimiento),
      telefonomovil: props.edituser.telefonomovil,
      email: props.edituser.email,
      habilitado: props.edituser.habilitado,
      curp: props.edituser.curp,
      */
    },
  });  

  const [lgShow, setLgShow] = useState(false);
  const [Errmessage, setErrmessage] = useState("");
  const [Showerror, setShowerror] = useState("");
  const [Sucmessage, setSuccmessage] = useState("");
  const [Showsuccess, setShowsuccess] = useState("");
  const [Submitted, setSubmitted] = useState(false);
  const [mode, setMode] = useState(props.mode);


  const [nombrecompetencia, setnombrecompetencia] = useState("");
  const [descripcioncompetencia, setdescripcioncompetencia] = useState("");    
  const [fechainicio, setfechainicio] = useState("");    
  const [fechafin, setfechafin] = useState("");    
  const [organigramaId, setorganigramaId] = useState(props.competencia.organigrama?props.competencia.organigrama.id:0);    
  const [organigramas, setorganigramas] = useState([]);  
  
  const { user } = useSelector(state => state.auth);

  const onChangeidorganigrama = (e) => {  
    //console.log(e.target.value);
    const organigramaId = e.target.value;
    setorganigramaId(organigramaId);
  };
  
  const handleClose = () => {
    window.location.reload();
    setLgShow(false);
  }
  
  const handleShow = () => {
    OrganigramaDataService.getOrganigramaByDescr('','id','ASC')
    .then(response => {
        console.log(response.data);
        setSuccmessage('');
        setErrmessage('');
        setShowerror(false);
        setShowsuccess(false);      
        setorganigramas(response.data);
        //setnombrecompetencia(response.data.nombrecompetencia);
        //setdescripcioncompetencia(response.data.descripcioncompetencia);
        //setfechainicio(response.data.fechainicio);
        //setfechafin(response.data.fechafin);
        setLgShow(true);        
      })      
    .catch(e => {
      console.log(e);
    });     
  }

  let handleValidations = () => {
    /*
    console.log(userRoles.length);
    if (username.length ==0 || userRoles.length == 0) {      
      setErrmessage('Campos requeridos.');
      setShowerror(true);
      return;
    }
    if (email) {
      if (!/\S+@\S+\.\S+/.test(email)) {
        setErrmessage('El correo no es válido.');
        setShowerror(true);      
        return;
      }
    }
    */
    saveAsignacionOrganigrama();
  } 

  let saveAsignacionOrganigrama = (e)  =>{ 
    console.log(e);
    console.log(nombrecompetencia);
    console.log(descripcioncompetencia);
    console.log(e.nombrecompetencia);
    console.log(e.descripcioncompetencia);  
    
    var data = {
    organigramaId: e.organigramaId,
    }
    
    console.log(data);
    
    CompetenciaDataService.update(props.id, data)
    .then(response => {
      setSubmitted(true);
      setSuccmessage('Se asignó el organigrama correctamente a la competencia.');
      setShowsuccess(true);
      setErrmessage('');
      setShowerror(false);        
      handleClose();
    })
    .catch(e => {
    console.log(e);
    setErrmessage(e.response?e.response.data.message:e.message);
    setShowerror(true);      
    setSuccmessage('');
    setShowsuccess(false);            
    })   
  }


    return (
      <>
        <Button variant={props.competencia.organigrama?"link":"primary"} onClick={handleShow}>
          {props.competencia.organigrama?props.competencia.organigrama.nombreorganigrama:"Asignar"}
        </Button>      
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => {handleClose();setLgShow(false)}}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'Asignar organigrama'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Form noValidate onSubmit={handleSubmit(saveAsignacionOrganigrama)}>
              <Row className='mt-2'>
                <Col className='col-md-3' md={8}>
                  <Form.Label>Nombre competencia</Form.Label>
                  <FormControl style={{maxWidth:"300px"}} type="text" name="nombrecompetencia" id="nombrecompetencia" disabled defaultValue={props.competencia?props.competencia.nombrecompetencia:null}></FormControl>
                </Col>
              </Row>                
              <Row className='mt-2'>
                <Col className='col-md-3' md={8}>
                  <Form.Label>Asignar organigrama</Form.Label>
                    <Controller
                        name="organigramaId"
                        control={control}
                        onChange={onChangeidorganigrama}
                        defaultValue={organigramaId}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Form.Select
                            {...field}
                              //onChange={onchangearean2}
                              className="mt-2"
                              type="select"
                              //placeholder="Nombre competencia"
                              isInvalid={errors.organigramaId}
                              defaultValue={props.competencia.organigramaId}
                            >
                              <option key={0} value={0}>{"Seleccionar"}</option>
                              {
                                organigramas.map((row,index) => {
                                  return (
                                    <option key={index} value={row.id}>{row.nombreorganigrama}</option>
                                  )
                                })
                              }
                            </Form.Select>
                        )}
                    />
                    {errors.organigramaId && (
                        <Form.Control.Feedback type="invalid">
                          Seleccione un organigrama.
                        </Form.Control.Feedback>
                    )}
                </Col>                 
              </Row>
              <hr />
              <div className="d-flex justify-content-start flex-wrap">      
         
                <button className="btn btn-secondary btn-block">
                  Guardar y cerrar
                </button>            
              </div> 

            </Form>
              {Showerror && (
                <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                  <Alert.Heading>Error</Alert.Heading>
                  <p>{Errmessage}</p>
                </Alert>      
              )}
              {Showsuccess && (
                <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                  <Alert.Heading>Hecho</Alert.Heading>
                  <p>{Sucmessage}</p>
                </Alert>      
              )}     
          </Modal.Body>
        </Modal>
      </>
    );
  }

  
  export default AsignarOrganigrama;